exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero[data-v-05e43b84]{margin-bottom:20px;margin-top:20px}.content[data-v-05e43b84]{margin-top:60px;margin-bottom:60px}.is-600x600[data-v-05e43b84]{max-height:450px;max-width:450px}.is-black-ducter[data-v-05e43b84]{background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e43b84","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing_Componentes/Sustentabilidad.vue
// module id = 1588
// module chunks = 0